import { Box, Text } from "theme-ui";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import getOr from "lodash/fp/getOr";
import flow from "lodash/fp/flow";
import castArray from "lodash/fp/castArray";
import filter from "lodash/fp/filter";
import head from "lodash/fp/head";

import { selectUserChoiceValues } from "store/app";
import { useMeasure, useTranslation } from "hooks";
import * as selectors from "store/app";
import { filterByDisplayIf } from "utils";
import * as styles from "./SkatePersonalizationCallOut.styles";

export default function SkatePersonalizationCallOut({
  backgroundColor,
  backgroundImage,
  position,
  zIndex,
  playerNameSelector,
  playerNumberSelector,
}) {
  const { t } = useTranslation();

  const [ref, bounds] = useMeasure({ debounce: 300 });
  const isVisible = Boolean(bounds?.height);

  const playerName = useSelector(selectors[playerNameSelector]);
  const playerNumber = useSelector(selectors[playerNumberSelector]);
  const noPersonalization = useSelector(
    getOr(false, ["app", "userChoiceValues", "noPersonalization"])
  );

  const userChoiceValues = useSelector(selectUserChoiceValues);

  if (noPersonalization) {
    return null;
  }

  const getCss = flow(
    castArray,
    filter((aPosition) =>
      filterByDisplayIf(userChoiceValues)(aPosition?.displayIf)
    ),
    head,
    getOr({}, "css")
  );

  return (
    <Box sx={styles.personalizationCallOut} ref={ref}>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <Box
            sx={styles.callout({
              bounds,
              backgroundColor,
              position: getCss(position),
              zIndex,
            })}
          >
            <Box sx={styles.disclaimerContainer}>
              <Text as="div" variant="copy4Medium" sx={styles.outerLabel}>
                {t("Tongue personalization")}
              </Text>

              <Text as="div" sx={styles.disclaimer}>
                {t("For Representation Only")}
              </Text>
            </Box>

            <Box
              sx={styles.calloutImage({
                backgroundImageUrl: backgroundImage.url,
              })}
            >
              <Text as="div" sx={styles.number}>
                {playerNumber}
              </Text>

              <Text as="div" sx={styles.text}>
                {playerName}
              </Text>

              {/* <Box sx={styles.line({ side })}>
                <Box
                  as="svg"
                  width="46"
                  height="37"
                  viewBox="0 0 46 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M46 1H36L1 36" stroke="black" />
                </Box>
              </Box> */}
            </Box>
          </Box>
        </motion.div>
      )}
    </Box>
  );
}
